<template>
  <!-- <h2>楓之谷R儲值流程</h2> -->
  <div class="thCss">
    <h3>1. Selección de servidor</h3>
    <p>
      Seleccione el servidor de juego correspondiente según su región. Tenga en
      cuenta que los datos de los personajes no son compartidos entre diferentes
      servidores.
    </p>
    <p>
      Por ejemplo, el personaje que haya creado en el servidor de América no
      aparecerá en la lista de jugadores ni en los rankings del servidor de
      Europa.
    </p>
    <img src="./../../../assets/info/es/1.png" />

    <h3>2. Inicio de sesión/Registro</h3>
    <p>
      Actualmente, el juego soporta 4 métodos de inicio de sesión, incluyendo
      inicio de sesión rápido, inicio de sesión por Facebook, inicio de sesión
      por la cuenta de Google y inicio de sesión por correo electrónico (Si
      usted es un jugador de Estados Unidos con una cuenta en la versión móvil,
      vincule primero un correo electrónico a su cuenta antes de iniciar sesión
      en la versión web. De esta forma, podrá jugar en la versión web con el
      mismo personaje de su cuenta.)
    </p>
    <img src="./../../../assets/info/es/2.png" />
    <p>
      Para un registro rápido, seleccione [Registrar], introduzca manualmente
      una cuenta personalizada y una contraseña personalizada, vuelva a
      introducir la contraseña y haga clic en el botón [Registrar] a
      continuación para completar el registro de la cuenta e ingresar al juego
    </p>
    <img src="./../../../assets/info/es/3.png" />

    <h3>
      3. Centro de recarga（¡Puedes disfrutar de hasta un 20% de reembolso）
    </h3>
    <p>
      1.En la versión de PC, tras entrar al juego, sube el nivel de tu personaje
      a 17 para desbloquear la [Función de Recarga]. Haz clic en [Tienda] en la
      esquina superior izquierda o en el ícono de [Diamante Azul] para acceder a
      la página de compra de paquetes.
    </p>
    <img src="./../../../assets/info/es/3_1.png" />
    <p>
      2. Haz clic en cualquier paquete para abrir la página de recarga y
      selecciona tu país y tu idioma:
    </p>
    <img src="./../../../assets/info/es/3_2.png" />
    <p>3.Selecciona tu método de pago y elige los artículos que deseas:</p>
    <img src="./../../../assets/info/es/3_3.png" />
    <p>
      4. Accede a la pantalla de confirmación de compra, verifica tu servidor y
      la información de tu personaje, y una vez todo esté correcto, procede con
      el pago:
    </p>
    <img src="./../../../assets/info/es/3_4.png" />
    <img src="./../../../assets/info/es/3_5.png" />
    <p>
      5. Después de completar el pago, podrás regresar al juego y reclamar los
      Diamantes de Color que adquiriste. (Los Diamantes de Color son una moneda
      importante dentro del juego, se pueden usar para comprar cualquier paquete
      de pago, recargar Diamantes Azules, y además aumentan la reputación de
      pago al usarlos).
    </p>
    <img src="./../../../assets/info/es/3_6.png" />
    <h3>Más funciones de página</h3>
    <h3>1. Descargar</h3>
    <p>
      Haga clic en [Instalar] para abrir la página del juego en una ventana
      separada. A continuación, se puede fijar a la barra de tareas del
      escritorio para un acceso rápido. También puede encontrar el icono de
      lanzamiento en el menú [Inicio].
    </p>
    <img src="./../../../assets/info/es/4.png" />
    <h3>2. Página web oficial</h3>
    <p>
      Haga clic en [Sitio web] para acceder a la página oficial y obtener la
      información más reciente.
    </p>
    <img src="./../../../assets/info/es/5.png" />
    <h3>3. Recoger</h3>
    <p>
      Haga clic en [Recoger], la página se añadirá a los favoritos del
      navegador, puede abrir el juego directamente en los favoritos del
      navegador.
    </p>

    <img src="./../../../assets/info/es/6.png" />

    <h3>4. Servicio al Cliente</h3>
    <p>
      Haga clic en el botón [Servicio al Cliente] para entrar en el centro de
      servicio al cliente donde puede ver las preguntas frecuentes rápidas para
      encontrar soluciones. Si las preguntas rápidas aún no resuelven su
      problema, visite la página oficial de Facebook y envíe un mensaje al CM
      para obtener ayuda
    </p>
    <p>
      Facebook：<a href="https://www.facebook.com/Global.MapleStoryR"
        >https://www.facebook.com/Global.MapleStoryR</a
      >
    </p>
    <img src="./../../../assets/info/es/7.png" />
  </div>
</template>

<script>
export default {
  name: "RastarTh",
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
